import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

/* CSS */
import './style.js'

if (process.env.NODE_ENV === 'production') {
  Vue.config.devtools = false
  Vue.config.debug = false
  Vue.config.silent = true
} else {
  Vue.config.productionTip = false
}

new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')
